'use client';

import React, {useEffect} from "react";
import {usePrivy} from "@privy-io/react-auth";
import {useRouter} from "next/navigation";
import Loading from "@/app/components/Loading";
import HeaderContainer from "@/app/components/HeaderContainer";

type IndexProps = Readonly<{
    children: React.ReactNode;
}>;

export default function IndexLayout({children}: IndexProps) {
    const {ready, authenticated} = usePrivy();
    const router = useRouter();

    useEffect(() => {
        if (ready && !authenticated) {
            router.push('/login', {scroll: false});
        }
    }, [ready, authenticated, router]);

    if (!ready) {
        return (
            <Loading/>
        );
    }

    if (!authenticated) {
        return null;
    }

    return (
        <div className="relative min-h-screen flex flex-col font-neutra">
            <HeaderContainer/>
            <main className="flex-1">
                {children}
            </main>
        </div>
    );
}
